import { css, type Interpolation } from 'styled-components';

export const sizes = {
  xxl: 1400,
  xl: 1200,
  lg: 992,
  md: 768,
  sm: 576,
  xs: 500
} as const;

type Breakpoint = keyof typeof sizes;
type MediaFunction = (
  strings: TemplateStringsArray,
  ...interpolations: Interpolation<object>[]
) => ReturnType<typeof css>;

export const media = (Object.keys(sizes) as Breakpoint[]).reduce(
  (accumulator, label) => {
    // use em in breakpoints to work properly cross-browser and support users
    // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
    const emSize = sizes[label] / 16;

    accumulator[label] = (strings, ...args) => css`
      @media (min-width: ${emSize}em) {
        ${css(strings, ...args)};
      }
    `;

    return accumulator;
  },
  {} as Record<Breakpoint, MediaFunction>
);
